import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetPrivacy = createAsyncThunk<AxiosResponse<any, any>, any>(
  "privacy/toGetPrivacy",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/privacy-policy?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
